class RangeSlider {
    constructor(element, options = {}) {
        this.element = element;
        this.options = Object.assign({
            min: 1,
            max: 10,
            step: 1,
            defaultValue: [1, 10],
            filterKey: 'filter.p.m.custom.frame_width',
            debounceDelay: 300,
            enablePageRerender: true,
            availableValues: []
        }, options);

        this.runway = this.element.querySelector('.el-slider__runway');
        this.bar = this.element.querySelector('.el-slider__bar');
        this.handles = Array.from(this.element.querySelectorAll('.el-slider__button-wrapper'));
      console.log('init handle', this.handle, "  element: ",  this.element)
        this.tooltips = Array.from(this.element.querySelectorAll('.el-tooltip'));
        this.value = [...this.options.defaultValue];
        this.valueDisplay = document.getElementById(`${this.element.id}-value`);
        
        this.dragging = false;
        this.currentHandle = null;
        this.debounceTimeout = null;

        // Sort available values if provided
        if (this.options.availableValues.length > 0) {
            this.options.availableValues.sort((a, b) => a - b);
        }

        this.init();
    }

    init() {
        // Parse current URL parameters on load
        this.parseUrlParams();
        
        // Set initial positions
        this.setValue(this.value);

        // Add event listeners
        this.handles.forEach((handle, index) => {
            handle.addEventListener('mousedown', (e) => this.startDrag(e, index));
        });

        this.runway.addEventListener('click', (e) => this.clickOnRunway(e));

        document.addEventListener('mousemove', (e) => this.drag(e));
        document.addEventListener('mouseup', () => this.endDrag());
        
        // Prevent text selection while dragging
        this.element.addEventListener('selectstart', (e) => {
            if (this.dragging) e.preventDefault();
        });

        // Handle browser back/forward
        window.addEventListener('popstate', () => {
            this.parseUrlParams();
            this.setValue(this.value);
        });
    }

    refreshSlider(newOptions = {}) {
      // Remove existing event listeners
      this.cleanup();
      
      // Update options if provided
      this.options = Object.assign(this.options, newOptions);
      
      // Reset values
      this.value = [...this.options.defaultValue];
      
      // Re-parse URL params
      this.parseUrlParams();
      
      // Reinitialize
      this.init();
    }

      // Static method to refresh a specific slider
    static refreshSlider(sliderId, html = null) {
        const sliderElement = document.getElementById(sliderId);
        const sliderInstance = window.rangeSliders[sliderId];
        if (sliderElement && sliderInstance) {
            
            // Reinitialize
            sliderInstance.init();
        }
    }

    parseUrlParams() {
      const urlParams = new URLSearchParams(window.location.search);
      console.log("urllenghth: ", urlParams.size)

      if(urlParams.size === 0) {
        localStorage.removeItem(`${this.element.id}-range`);
      }
      
      
      // *** localStorage changes ***
        const storedRange = localStorage.getItem(`${this.element.id}-range`);
        if (storedRange) {
            try {
                const parsed = JSON.parse(storedRange);
                if (Array.isArray(parsed) && parsed.length === 2) {
                    this.value = parsed;
                    this.setValue(this.value);
                    return;
                }
            } catch (e){
              console.log("ERR", e)
            }
        }
        // *** end localStorage changes ***

        const filterParams = [];
        
        // Get all filter parameters for this key
        for (const [key, value] of urlParams.entries()) {
            if (key === this.options.filterKey) {
                const numValue = parseInt(value);
                if (!isNaN(numValue) && numValue >= this.options.min && numValue <= this.options.max) {
                    filterParams.push(numValue);
                }
            }
        }

        if (filterParams.length > 0) {
            filterParams.sort((a, b) => a - b);
            this.value = [filterParams[0], filterParams[filterParams.length - 1]];
        } else {
            this.value = [...this.options.defaultValue];
        }
    }

    startDrag(e, handleIndex) {
        e.preventDefault();
        this.dragging = true;
        this.currentHandle = handleIndex;
        this.handles[handleIndex].classList.add('dragging');
    }

    drag(e) {
        if (!this.dragging) return;
        
        const rect = this.runway.getBoundingClientRect();
        let percent = (e.clientX - rect.left) / rect.width * 100;
        
        // Clamp the percent between 0 and 100
        percent = Math.max(0, Math.min(percent, 100));
        
        // Convert percentage to value
        let value = this.percentToValue(percent);
        
        // Apply step if needed
        if (this.options.step > 0) {
            value = Math.round(value / this.options.step) * this.options.step;
        }

        // Ensure handles don't cross each other
        if (this.currentHandle === 0) {
            value = Math.min(value, this.value[1]);
        } else {
            value = Math.max(value, this.value[0]);
        }

        this.value[this.currentHandle] = value;
        this.updatePositions();
        this.debouncedUpdate();
    }

    endDrag() {
        if (this.dragging) {
            this.dragging = false;
            if (this.currentHandle !== null) {
                this.handles[this.currentHandle].classList.remove('dragging');
                this.currentHandle = null;
            }
            // Final update when drag ends
            this.updateUrlAndRerender();
        }
    }

    clickOnRunway(e) {
        const rect = this.runway.getBoundingClientRect();
        let percent = (e.clientX - rect.left) / rect.width * 100;
        
        // Convert percentage to value
        let value = this.percentToValue(percent);
        
        // Apply step if needed
        if (this.options.step > 0) {
            value = Math.round(value / this.options.step) * this.options.step;
        }

        // Determine which handle to move (the closest one)
        const distToFirst = Math.abs(value - this.value[0]);
        const distToSecond = Math.abs(value - this.value[1]);
        
        if (distToFirst <= distToSecond) {
            this.value[0] = value;
        } else {
            this.value[1] = value;
        }

        // Ensure handles don't cross
        this.value.sort((a, b) => a - b);
        
        this.updatePositions();
        this.updateUrlAndRerender();
    }

    setValue(values) {
        this.value = [...values];
        this.updatePositions();
    }

    updatePositions() {
        console.log("Updating Position...", this.handles, this.value)
        // Update handle positions
        this.handles.forEach((handle, index) => {
            const percent = this.valueToPercent(this.value[index]);
            handle.style.left = `${percent}%`;
            
            // Update tooltip
            const tooltip = handle.querySelector('.el-tooltip');
            if (tooltip) {
                tooltip.textContent = this.value[index];
            }
        });
        
        // Update bar position (between the two handles)
        const leftPercent = this.valueToPercent(this.value[0]);
        const rightPercent = this.valueToPercent(this.value[1]);
        
        this.bar.style.left = `${leftPercent}%`;
        this.bar.style.width = `${rightPercent - leftPercent}%`;
        
        // Update value display
        if (this.valueDisplay) {
            this.valueDisplay.textContent = `[${this.value[0]}, ${this.value[1]}]`;
        }
    }

    debouncedUpdate() {
        if (this.debounceTimeout) {
            clearTimeout(this.debounceTimeout);
        }
        this.debounceTimeout = setTimeout(() => {
            this.updateUrlAndRerender();
        }, this.options.debounceDelay);
    }

    updateUrlAndRerender() {
       // *** localStorage changes ***
        localStorage.setItem(`${this.element.id}-range`, JSON.stringify(this.value));
        // *** end localStorage changes ***

        // Get existing URL parameters
        const currentUrl = new URL(window.location);
        const urlParams = new URLSearchParams();
        
        // Remove all existing parameters for this filter key
        for (const [key, value] of currentUrl.searchParams.entries()) {
            if (key !== this.options.filterKey) {
                urlParams.append(key, value);
            }
        }

        // Get values to add to URL based on current range
        const valuesToAdd = this.getValuesInRange();
        console.log("valuesToAdd: ", valuesToAdd)
        
        // Add the specific values that fall within the selected range
        valuesToAdd.forEach(value => {
            console.log("urlParams: ", urlParams)
            urlParams.append(this.options.filterKey, value.toString());
        });

        // Create the search params string
        const searchParamsString = urlParams.toString();
        console.log("searchParamsString: ", searchParamsString)

        // Update URL and trigger page rerender if enabled
        if (this.options.enablePageRerender && typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.renderPage) {
            const newUrl = `${currentUrl.pathname}?${searchParamsString}`;
            window.history.replaceState({}, '', newUrl);
            // Use FacetFiltersForm to rerender the page
            FacetFiltersForm.renderPage(searchParamsString, null, false);


            // *** localStorage changes ***
            const storedRange = localStorage.getItem(`${this.element.id}-range`);
            console.log("StoredRange: ", storedRange)
            if (storedRange) {
                try {
                    const parsed = JSON.parse(storedRange);
                    if (Array.isArray(parsed) && parsed.length === 2) {
                        this.value = parsed;
                        this.setValue(this.value);
                        return;
                    }
                } catch {}
            }
            // *** end localStorage changes ***

          
        } else {
            // Fallback: just update URL without rerendering
            const newUrl = `${currentUrl.pathname}?${searchParamsString}`;
            window.history.replaceState({}, '', newUrl);
        }
    }

    valueToPercent(value) {
        return ((value - this.options.min) / (this.options.max - this.options.min)) * 100;
    }

    percentToValue(percent) {
        return this.options.min + ((percent / 100) * (this.options.max - this.options.min));
    }

    // Get values from availableValues array that fall within the current range
    getValuesInRange() {
        if (this.options.availableValues.length === 0) {
            // Fallback to all integers in range if no specific values provided
            const values = [];
            for (let i = this.value[0]; i <= this.value[1]; i++) {
                values.push(i);
            }
            return values;
        }

        // Return only the available values that fall within the selected range
        return this.options.availableValues.filter(value => 
            value >= this.value[0] && value <= this.value[1]
        );
    }

    // Public method to get current filter values (for integration with other code)
    getFilterValues() {
        return this.getValuesInRange();
    }

    // Public method to get filter parameter object (for Shopify integration)
    getFilterParams() {
        const params = {};
        const values = this.getFilterValues();
        values.forEach(value => {
            if (!params[this.options.filterKey]) {
                params[this.options.filterKey] = [];
            }
            params[this.options.filterKey].push(value.toString());
        });
        return params;
    }

    // Public method to disable/enable page rerendering
    setPageRerender(enabled) {
        this.options.enablePageRerender = enabled;
    }

    // Public method to update available values
    setAvailableValues(values) {
        this.options.availableValues = [...values].sort((a, b) => a - b);
    }

    // Public method to get available values
    getAvailableValues() {
        return [...this.options.availableValues];
    }
}